import styled, { keyframes } from "styled-components";

interface ResponsiveProps {
  $isPhone?: boolean;
}

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const SkeletonBox = styled.div<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "100%" : "168.12px")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "115.99px")};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;

const SkeletonText = styled.div<{
  $width?: string;
  $height?: string;
  $isPhone?: boolean;
}>`
  width: ${({ $width, $isPhone }) => {
    if ($isPhone) {
      return $width === "80%" ? "90%" : $width === "60%" ? "70%" : "100%";
    }
    return $width || "100%";
  }};
  height: ${({ $height, $isPhone }) => {
    if ($isPhone) {
      return $height === "9.94px"
        ? "10px"
        : $height === "8.52px"
          ? "9px"
          : "12px";
    }
    return $height || "12px";
  }};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 2px;
  margin-top: 4px;
`;

const PropertyCardSkeleton = ({ $isPhone = false }: ResponsiveProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: $isPhone ? "100%" : "fit-content",
        alignItems: "start",
        padding: "6px",
        borderRadius: "6px",
      }}
    >
      <SkeletonBox $isPhone={$isPhone} />
      <SkeletonText $width="80%" $height="9.94px" $isPhone={$isPhone} />
      <SkeletonText $width="60%" $height="8.52px" $isPhone={$isPhone} />
    </div>
  );
};

export default PropertyCardSkeleton;
